import { render } from "./TwoFactorAuth.vue?vue&type=template&id=6a01a0ee"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__